import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { BookOpenIcon, CheckSquareIcon, HeadphonesIcon, CalendarIcon } from 'lucide-react';
import { SectionWrapper } from '../ui/SectionWrapper';
const packItems = [{
  icon: BookOpenIcon,
  title: 'Ebook en PDF imprimible',
  description: 'Guía completa con todo el método explicado paso a paso.'
}, {
  icon: CheckSquareIcon,
  title: 'Checklists de rutina día y noche',
  description: 'Listas prácticas para seguir cada día sin olvidar nada.'
}, {
  icon: HeadphonesIcon,
  title: 'Audio de acompañamiento',
  description: 'Contenido en audio para escuchar cuando lo necesites.'
}, {
  icon: CalendarIcon,
  title: 'Ruta estructurada de 6 semanas',
  description: 'Plan organizado semana a semana para avanzar con claridad.'
}];
export function PackSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <SectionWrapper background="cream" data-id="element-131">
      <div ref={ref} className="grid md:grid-cols-2 gap-12 items-center" data-id="element-132">
        {/* Image */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={isInView ? {
        opacity: 1,
        x: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-133">
          <img src="https://cdn.magicpatterns.com/uploads/tEiwUDpUwTSy8CX73r8GUS/1._MOCKUP_NOCHES_SECAS.png" alt="Pack completo Noches Secas: ebook, tablet y audio" className="w-full h-auto" data-id="element-134" />
        </motion.div>

        {/* Content */}
        <div data-id="element-135">
          <h2 className="font-serif text-3xl md:text-4xl text-navy mb-8" data-id="element-136">
            Todo lo que necesitas en un solo método
          </h2>

          <ul className="space-y-6 mb-8" data-id="element-137">
            {packItems.map((item, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: 20
          }} animate={isInView ? {
            opacity: 1,
            x: 0
          } : {}} transition={{
            delay: 0.2 + index * 0.1
          }} className="flex items-start gap-4" data-id="element-138">
                <span className="flex-shrink-0 w-12 h-12 rounded-xl bg-gold/10 flex items-center justify-center" data-id="element-139">
                  <item.icon className="w-6 h-6 text-gold" data-id="element-140" />
                </span>
                <div data-id="element-141">
                  <h3 className="font-semibold text-navy text-lg" data-id="element-142">
                    {item.title}
                  </h3>
                  <p className="text-navy/60" data-id="element-143">{item.description}</p>
                </div>
              </motion.li>)}
          </ul>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          delay: 0.6
        }} className="text-navy/70 text-lg bg-white p-4 rounded-xl" data-id="element-144">
            Todo está diseñado para que sepas exactamente qué hacer y cuándo
            hacerlo.
          </motion.p>
        </div>
      </div>
    </SectionWrapper>;
}